<template>
  <div class="tdt-container">
    <div id="mapContainer" class="tdtMapView">
    </div>
    <div class="tdtMapOverlay" :style="{ left: pos.x + 'px', top: pos.y + 'px' }" v-if="mapLoaded">
      <i class="iconfont icon-dizhi"></i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      location: {
        lng: 113.622222,
        lat: 35.032839,
      }, // 指定地点的经纬度
      zoom: 14, // 地图缩放比例
      map: null,
      marker: null,
      mapLoaded: false,
      pos: {
        x: 0,
        y: 0
      }
    };
  },
  mounted() {
    this.loadTianditu()
      .then(() => {
        this.initMap();
      })
      .catch((error) => {
        console.log("天地图加载失败", error);
      });
  },
  beforeDestroy() {

  },
  computed: {
  },
  methods: {
    loadTianditu() {
      if (window.T) {
        return Promise.resolve(window.T);
      }
      if (window.__tiandituLoader) {
        return window.__tiandituLoader;
      }
      window.__tiandituLoader = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src =
          "https://api.tianditu.gov.cn/api?v=4.0&tk=fc141faa4ba523309d362c9e7d8c6271";
        script.async = true;
        script.onload = () => resolve(window.T);
        script.onerror = () => reject(new Error("tianditu script failed"));
        document.head.appendChild(script);
      });
      return window.__tiandituLoader;
    },
    initMap() {
      if (!window.T) {
        return;
      }
      this.map = new T.Map('mapContainer');
      let lnglat = new T.LngLat(this.location.lng, this.location.lat)
      this.map.centerAndZoom(lnglat, this.zoom);
      // 地图移动结束事件
      this.map.addEventListener('moveend', () => {
        console.log('地图移动结束')
        try {
          this.addMapOverlay();
        } catch (error) {
          console.log('添加地图覆盖物失败', error)
        }
      })
      this.map.addEventListener('movestart', () => {
        this.mapLoaded = false
      })
      try {
        this.addMapOverlay();
      } catch (error) {
        console.log('添加地图覆盖物失败', error)
      }

    },
    addMapOverlay() {
      this.$nextTick(() => {
        this.mapLoaded = true
        let lnglat = new T.LngLat(this.location.lng, this.location.lat)
        let point = this.map.lngLatToContainerPoint(lnglat)
        this.pos.x = point.x
        this.pos.y = point.y
        // let icon = new T.Icon({
        //   iconUrl: "http://api.tianditu.gov.cn/img/map/marker.png",
        //   iconSize: new T.Point(12, 20),
        //   iconAnchor: new T.Point(6, 40),
        // });
        // const marker = new T.Marker(lnglat, { icon: icon })
        // this.map.addLayer(marker)
        // this.map.wQ("addoverlay", {
        //   addoverlay: marker
        // })
      })
    }
  }
};
</script>

<style scoped>
.tdt-container {
  width: 100%;
  height: 480px;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}

.tdtMapView {
  width: 100%;
  height: 100%;
  z-index: 1;
}

.tdtMapOverlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  font-size: 16px;
  color: red;
  transform: translate(0, -100%);
}
</style>
